import {ChangeRequestStatus} from 'src/openapi/models/ChangeRequestStatus';

import {StringFilterItem} from '../typedefs';

type Params = {
    changeRequestsMapped: StringFilterItem[],
    code: string,
    source: string,
    userEmail: string,
};

export const findEditChangeRequest = ({
    changeRequestsMapped,
    code,
    source,
    userEmail,
}: Params) => changeRequestsMapped.find(request =>
    code && source
    && request.name === code
    && request.authorEmail === userEmail
    && request.source === source
    && (request.status === ChangeRequestStatus.NEW || request.status === ChangeRequestStatus.REOPENED),
);
